import { css, cx } from '@emotion/css';
import React, { useMemo } from 'react';
import { Text } from 'slate';
import { RenderLeafProps } from 'slate-react';

interface LeafType extends Text {
  bold: boolean;
  italic: boolean;
}

const styles = {
  bold: css`
    font-weight: 800;
  `,
  italic: css`
    font-style: italic;
  `,
};

interface Props extends RenderLeafProps {
  leaf: LeafType;
  attributes: any;
  children: any;
}

const Leaf = (props: Props) => {
  const { leaf, attributes, children } = props;
  const destClassName = useMemo(() => {
    const classes = [];
    if (leaf.bold) {
      classes.push(styles.bold);
    }
    if (leaf.italic) {
      classes.push(styles.italic);
    }
    return classes;
  }, [leaf.bold, leaf.italic]);
  return (
    <span {...attributes} className={cx(...destClassName)}>
      {children}
    </span>
  );
};

export default Leaf;
